import React, { useState } from "react";
import Tooltip from '@mui/material/Tooltip';
import { HideIcon, NotVerified, ShowIcon } from "../Utility/ImageImports";
const CommonInput = ({
  onClick,
  onChange,
  name,
  warningBorder = false,
  value,
  type = "text",
  label,
  placeholder,
  className = "",
  className2 = "",
  className3 = "",
  className4 = "",
  max_input,
  min_input,
  min_number,
  max_number,
  is_readonly = false,
  no_label = false,
  icon = null,
  pipe = false,
  textarea = false,
  rows,
  cols = 15,
  togglePasswordBtn = false,
  required = false,
  disabled = false,
  startDate,
  inputIcon = false,
  notEditable = false
}) => {
  const [showPassword, setShowPassword] = useState(false);
  const [inputType, setInputType] = useState(type);

  const maxLengthCheck = (object) => {
    if (object.target.value.length > object.target.maxLength) {
      object.target.value = object.target.value.slice(0, object.target.maxLength)
    }
  }
  return (
    <div>
      {!no_label && (
        <div
          className={`text-cHighlighted text-fs14 font-fw600 mb-s15 capitalize w-full ${required === true ? "req-field" : ""}`}
        >
          {label}
        </div>
      )}

      <div
        className={`${className2} ${icon && "relative flex justify-center items-center w-full"
          }`}
      >
        <div className={`${togglePasswordBtn === true ? "relative" : ""}  ${disabled === true && notEditable === true ? 'relative' : ''}`}>
          {inputIcon && <div className="absolute left-0 pb-s14 pt-s10 ml-s10 mr-s10">
            <img className="w-s18 h-s18" src={inputIcon} alt="" /></div>}
          {!textarea && (
            <input
              disabled={disabled}
              required={required}
              onClick={onClick}
              onChange={onChange}
              type={inputType}
              name={name}
              value={value && value}
              data-date-format={type === "date" ? "DD MMMM YYYY" : ""}
              maxLength={max_input ? max_input : 4096}
              onInput={maxLengthCheck}
              minLength={min_input ? min_input : 0}
              max={max_number}
              // onFocus={(e) => { if (type === "date") e.target.readOnly = true }}
              onKeyDown={(e) => {
                if (type === "date") e.preventDefault();
                if (type === "number" && (e.key === "." || e.key === "+" || e.key === "-" || e.key === "e")) e.preventDefault();
              }}
              // onkeydown="return false"
              min={
                type === "number"
                  ? min_number
                  : type === "date"
                    ? startDate
                      ? startDate
                      : new Date().toISOString().split("T")[0]
                    : ""
              }
              className={`bg-cTextFieldGrey border  ${warningBorder ? "border-cRed" : "border-cNmSelect"}   ${!inputIcon ? 'px-5' : 'px-10'}  py-s7 w-full rounded-md text-cTextBlack ${className3} ${togglePasswordBtn === true ? "pr-s50" : ""
                }
                ${disabled ? "cursor-not-allowed" : "cursor-text"}
              `}
              placeholder={placeholder}
              readOnly={is_readonly}
            />
          )}
          {togglePasswordBtn === true ? (
            <img
              onClick={() => {
                setShowPassword(!showPassword);
                if (inputType === "password") {
                  setInputType("text");
                } else {
                  setInputType("password");
                }
              }}
              src={showPassword === true ? ShowIcon : HideIcon}
              alt="show-hide-icon"
              className="absolute top-1 right-3 p-2 cursor-pointer"
            />
          ) : (
            ""
          )}

          {disabled === true && notEditable === true ? (

            <Tooltip title="Not Editable">
              <img
                src={NotVerified}
                alt="show-hide-icon"
                className="absolute top-1 right-3 p-1.5 cursor-pointer"
              />
            </Tooltip>
          ) : (
            ""
          )}
        </div>

        {textarea && (
          <textarea
            // autoComplete={autoComplete}
            name={name}
            required={required}
            onChange={onChange}
            value={value && value}
            className={`px-5 py-3 w-full h-full rounded-md border resize-none bg-cTextFieldGrey border-cNmSelect text-cTextBlack ${className3}`}
            rows={rows}
            cols={cols}
            placeholder={placeholder}
          ></textarea>
        )}

        {icon && (
          <div
            className={`absolute right-1 px-2 ${pipe && "border-l"
              } border-cInputBorder text-gray-600 ${className4}`}
          >
            {icon}
          </div>
        )}
      </div>
    </div>
  );
};

export default CommonInput;